import React from 'react';
import Editor from '@monaco-editor/react';

export default function ReportBuilder({
	handleSubmit,
	host,
	setHost,
	hostList,
	setName,
	name,
	sql,
	setSql,
	recurrence,
	setRecurrence,
	selectedTable,
	onTableSelect,
	tables,
	tableDetails,
	columns,
	example,
	queryPage,
	setQueryPage
}) {
    return (
	  <form className="p-5 mb-10 ml-5 bg-white shadow" onSubmit={handleSubmit}>
			  <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">
				  Report Query Builder
			  </h2>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="configuration">Configuration</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="configuration"
				  placeholder={"Configuration"}
				  value={host}
				  onChange={(event) => setHost(event.target.value)}
				>
				  {hostList && hostList.map(item => (<option value="{item}">{item}</option>))}
				</select>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="name">Query Name</label>
				<input
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  type="text"
				  id="name"
				  value={name}
				  onChange={(event) => setName(event.target.value)}
				/>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="sql">SQL:</label>
				<Editor
				  height="25vh"
				  defaultLanguage="mysql"
					  theme="github"
	    			  value={sql}
				  onChange={(value, event) => setSql(value)}
				/>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="recurrence">Recurrence</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="recurrence"
				  placeholder={"Schedule"}
				  value={recurrence}
				  onChange={(event) => setRecurrence(event.target.value)}
				>
				  <option value="once">Once</option>
				  <option value="daily">Daily</option>
				  <option value="weekly">Weekly</option>
				  <option value="monthly">Monthly</option>
				  <option value="quarterly">Quarterly</option>
				  <option value="yearly">Yearly</option>
				</select>
			  </div>
			  <button className="text-gray-800 bg-white mt-3 ml-5 hover:text-purple-500 font-semibold py-2 px-4 border border-gray-400 rounded shadow" type="submit">Schedule</button>
		</form>
    )
}
